export default __webpack_public_path__ + "static/media/inline1.baf243d3.jpg";